import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, HeartPulse, ShieldAlert, Flame, Building2, TrendingUp } from 'lucide-react';
import { Card, CardContent } from '../Card';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
const sparklineData = [{
  value: 40
}, {
  value: 45
}, {
  value: 42
}, {
  value: 50
}, {
  value: 55
}, {
  value: 58
}, {
  value: 60
}, {
  value: 62
}];
export function KpiRow() {
  const navigate = useNavigate();
  return <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4" data-id="element-525">
      {/* KPI 1: Threat Level → /threat-intel */}
      <button onClick={() => navigate('/threat-intel')} className="block text-left w-full focus:outline-none focus:ring-2 focus:ring-primary/40 rounded-lg" data-id="element-526">
        <Card className="bg-card border-border/60 overflow-hidden relative hover:shadow-md hover:border-emerald-200 transition-all cursor-pointer h-full" data-id="element-527">
          <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-emerald-400 to-emerald-600" data-id="element-528"></div>
          <CardContent className="p-3 sm:p-4 pl-4 sm:pl-5" data-id="element-529">
            <div className="flex justify-between items-start" data-id="element-530">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground" data-id="element-531">
                Threat Level
              </span>
              <div className="size-7 rounded-md bg-emerald-50 border border-emerald-200 flex items-center justify-center" data-id="element-532">
                <Activity className="size-3.5 text-emerald-600" data-id="element-533" />
              </div>
            </div>
            <div className="mt-2 flex items-baseline gap-2" data-id="element-534">
              <span className="font-heading text-3xl sm:text-4xl font-bold text-foreground tracking-tight" data-id="element-535">
                62
              </span>
              <span className="text-xs font-semibold text-emerald-700 flex items-center" data-id="element-536">
                <TrendingUp className="size-3 mr-0.5" data-id="element-537" /> +4%
              </span>
            </div>
            <div className="mt-2 inline-flex items-center rounded bg-emerald-50 px-1.5 py-0.5 font-mono text-[9px] font-bold text-emerald-700 border border-emerald-200" data-id="element-538">
              STABIL
            </div>
            <div className="absolute bottom-0 left-0 right-0 h-10 opacity-30 pointer-events-none" data-id="element-539">
              <ResponsiveContainer width="100%" height="100%" data-id="element-540">
                <AreaChart data={sparklineData} data-id="element-541">
                  <Area type="monotone" dataKey="value" stroke="#10b981" fill="#10b981" strokeWidth={2} data-id="element-542" />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>
      </button>

      {/* KPI 2: Active Issues → /hot-issue */}
      <button onClick={() => navigate('/hot-issue')} className="block text-left w-full focus:outline-none focus:ring-2 focus:ring-primary/40 rounded-lg" data-id="element-543">
        <Card className="bg-card border-border/60 overflow-hidden relative hover:shadow-md hover:border-amber-200 transition-all cursor-pointer h-full" data-id="element-544">
          <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-400 to-amber-600" data-id="element-545"></div>
          <CardContent className="p-3 sm:p-4 pl-4 sm:pl-5" data-id="element-546">
            <div className="flex items-center justify-between mb-2" data-id="element-547">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground" data-id="element-548">
                Active Issues
              </span>
              <div className="size-7 rounded-md bg-amber-50 border border-amber-200 flex items-center justify-center" data-id="element-549">
                <HeartPulse className="size-3.5 text-amber-600" data-id="element-550" />
              </div>
            </div>
            <div className="mt-2" data-id="element-551">
              <span className="font-heading text-2xl font-bold text-amber-700 tracking-tight" data-id="element-552">
                CEMAS
              </span>
            </div>
            <div className="mt-4 flex w-full h-1.5 rounded-full overflow-hidden bg-muted" data-id="element-553">
              <div className="bg-emerald-500 h-full" style={{
              width: '30%'
            }} title="Optimis: 30%" data-id="element-554" />
              <div className="bg-amber-500 h-full" style={{
              width: '45%'
            }} title="Cemas: 45%" data-id="element-555" />
              <div className="bg-red-500 h-full" style={{
              width: '25%'
            }} title="Marah: 25%" data-id="element-556" />
            </div>
            <div className="mt-2 flex justify-between font-mono text-[9px] text-muted-foreground" data-id="element-557">
              <span className="text-emerald-700" data-id="element-558">OPT 30%</span>
              <span className="text-amber-700" data-id="element-559">CEM 45%</span>
              <span className="text-red-700" data-id="element-560">MAR 25%</span>
            </div>
          </CardContent>
        </Card>
      </button>

      {/* KPI 3: Bot Activity → /bot-detection */}
      <button onClick={() => navigate('/bot-detection')} className="block text-left w-full focus:outline-none focus:ring-2 focus:ring-primary/40 rounded-lg" data-id="element-561">
        <Card className="bg-card border-border/60 overflow-hidden relative hover:shadow-md hover:border-orange-200 transition-all cursor-pointer h-full" data-id="element-562">
          <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-orange-400 to-orange-600" data-id="element-563"></div>
          <CardContent className="p-3 sm:p-4 pl-4 sm:pl-5" data-id="element-564">
            <div className="flex items-center justify-between mb-2" data-id="element-565">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground" data-id="element-566">
                Bot Activity
              </span>
              <div className="size-7 rounded-md bg-orange-50 border border-orange-200 flex items-center justify-center" data-id="element-567">
                <Flame className="size-3.5 text-orange-600" data-id="element-568" />
              </div>
            </div>
            <div className="mt-2 flex items-baseline gap-2" data-id="element-569">
              <span className="font-heading text-3xl sm:text-4xl font-bold text-foreground tracking-tight" data-id="element-570">
                37
              </span>
              <span className="text-xs font-semibold text-red-700 flex items-center" data-id="element-571">
                <TrendingUp className="size-3 mr-0.5" data-id="element-572" /> +12
              </span>
            </div>
            <div className="mt-2 flex flex-col gap-0.5" data-id="element-573">
              <div className="truncate font-mono text-[10px] text-muted-foreground" data-id="element-574">
                <span className="text-orange-600 font-bold mr-1" data-id="element-575">#1</span> Harga
                beras melambung
              </div>
              <div className="truncate font-mono text-[10px] text-muted-foreground" data-id="element-576">
                <span className="text-orange-600 font-bold mr-1" data-id="element-577">#2</span> Hoaks
                bansos pangan
              </div>
            </div>
          </CardContent>
        </Card>
      </button>

      {/* KPI 4: Sentiment → /sentiment */}
      <button onClick={() => navigate('/sentiment')} className="block text-left w-full focus:outline-none focus:ring-2 focus:ring-primary/40 rounded-lg" data-id="element-578">
        <Card className="bg-card border-border/60 overflow-hidden relative hover:shadow-md hover:border-red-200 transition-all cursor-pointer h-full" data-id="element-579">
          <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-red-400 to-red-600" data-id="element-580"></div>
          <CardContent className="p-3 sm:p-4 pl-4 sm:pl-5" data-id="element-581">
            <div className="flex items-center justify-between mb-2" data-id="element-582">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground" data-id="element-583">
                Sentiment Score
              </span>
              <div className="size-7 rounded-md bg-red-50 border border-red-200 flex items-center justify-center" data-id="element-584">
                <ShieldAlert className="size-3.5 text-red-600" data-id="element-585" />
              </div>
            </div>
            <div className="mt-2 flex items-baseline gap-2" data-id="element-586">
              <span className="font-heading text-3xl sm:text-4xl font-bold text-foreground tracking-tight" data-id="element-587">
                14
              </span>
              <span className="font-mono text-[10px] text-muted-foreground" data-id="element-588">
                isu kritis
              </span>
            </div>
            <div className="mt-2 flex gap-1" data-id="element-589">
              <div className="flex-1 flex flex-col items-center justify-center rounded bg-red-50 border border-red-200 py-1" data-id="element-590">
                <span className="font-mono text-[8px] text-red-600/70" data-id="element-591">
                  KRT
                </span>
                <span className="font-mono text-xs font-bold text-red-700" data-id="element-592">
                  2
                </span>
              </div>
              <div className="flex-1 flex flex-col items-center justify-center rounded bg-amber-50 border border-amber-200 py-1" data-id="element-593">
                <span className="font-mono text-[8px] text-amber-600/70" data-id="element-594">
                  TGI
                </span>
                <span className="font-mono text-xs font-bold text-amber-700" data-id="element-595">
                  5
                </span>
              </div>
              <div className="flex-1 flex flex-col items-center justify-center rounded bg-blue-50 border border-blue-200 py-1" data-id="element-596">
                <span className="font-mono text-[8px] text-blue-600/70" data-id="element-597">
                  SDG
                </span>
                <span className="font-mono text-xs font-bold text-blue-700" data-id="element-598">
                  7
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
      </button>

      {/* KPI 5: Stability → /ipoleksosbudhankam */}
      <button onClick={() => navigate('/ipoleksosbudhankam')} className="block text-left w-full focus:outline-none focus:ring-2 focus:ring-primary/40 rounded-lg" data-id="element-599">
        <Card className="bg-card border-border/60 overflow-hidden relative hover:shadow-md hover:border-primary/30 transition-all cursor-pointer h-full" data-id="element-600">
          <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-primary/60 to-primary" data-id="element-601"></div>
          <CardContent className="p-3 sm:p-4 pl-4 sm:pl-5" data-id="element-602">
            <div className="flex items-center justify-between mb-2" data-id="element-603">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground" data-id="element-604">
                System Status
              </span>
              <div className="size-7 rounded-md bg-primary/10 border border-primary/20 flex items-center justify-center" data-id="element-605">
                <Building2 className="size-3.5 text-primary" data-id="element-606" />
              </div>
            </div>
            <div className="mt-2 flex items-baseline gap-2" data-id="element-607">
              <span className="font-heading text-3xl sm:text-4xl font-bold text-foreground tracking-tight" data-id="element-608">
                78
              </span>
              <span className="font-mono text-xs text-muted-foreground" data-id="element-609">
                /100
              </span>
            </div>
            <div className="mt-2 rounded bg-red-50 border border-red-200 p-1.5 flex items-center justify-between" data-id="element-610">
              <span className="font-mono text-[9px] text-red-700 font-semibold" data-id="element-611">
                TERENDAH:
              </span>
              <span className="font-mono text-[10px] font-bold text-red-700" data-id="element-612">
                KEMENDAG (42)
              </span>
            </div>
          </CardContent>
        </Card>
      </button>
    </div>;
}